export const LOGGED_IN = 'LOGGED_IN';

export const SESSION_EXPIRED = 'SESSION_EXPIRED';

export const STORE_USER_DATA = 'STORE_USER_DATA';

export const LOG_IN = 'LOG_IN';

export const REQUEST_ERROR = 'REQUEST_ERROR';
